export default __webpack_public_path__ + "static/media/history.8b5363f3.png";